<template>
    <div v-if='kbxmlc'>
        <div :class='["box",kbxmlc.zt=="2"||role!="Z"?"noBtn":""]'>
            <div class="clear">
                <p class="cont-title lf">符合性审查</p>
                <div class="rt">
                    <el-input v-model="tbdwmc" class="input-with-select lf" style="width:250px;margin:0 10px" placeholder="投标单位名称">
                        <el-button slot="append" icon="el-icon-search" @click='serachData'></el-button>
                    </el-input>
                    <el-button type="primary" @click="sc" v-if='role=="Z"&&kbxmlc.zt!="2"' :disabled="waitLoading">审查</el-button>
                    <el-button type="primary" @click="sc" v-else :disabled="waitLoading">查看</el-button>
                    <el-button type="primary" @click="yjsc" :disabled="kbxmlc.zt=='2'||waitLoading" v-if='role=="Z"'>一键审查</el-button>
                    <el-button type="primary" :disabled="!isOk||waitLoading" @click='dcFhxsc'>下载</el-button>
                </div>
            </div>
            <el-table
                ref="table"
                @selection-change="handleSelectionChange"
                @select="select"
                @select-all="onSelectAll"
                border
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column type="index" label="序号" width="60">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column prop="fCQYMC" label="投标单位名称" show-overflow-tooltip min-width="200"></el-table-column>
                <el-table-column prop="rpzt" label="审查结果" width="100">
                    <template slot-scope="scope">
                        <span class="red" v-if='scope.row.rpzt=="2"'>不通过</span>
                        <template v-if='scope.row.rpzt=="1"'>通过</template>
                    </template>
                </el-table-column>
                <el-table-column prop="rpyj" label="备注" show-overflow-tooltip min-width="200"></el-table-column>
            </el-table>
            <div class="clear">
                <span class="lf pageNum">共{{total}}家，审查通过{{sctg}}家，审查不通过{{scbtg}}家，剩余{{total-sctg-scbtg}}家。</span>
                <myPage
                class="rt"
                :total="total"
                :page-size="pageSize"
                :currentPage="currentPage"
                @changePage="changePage"
                ></myPage>
            </div>

            <el-button v-if="!isTbr && kbxmlc.zt!='2'" type="primary lcNext" :disabled="!isOk||waitLoading"   @click="nextBtn">下一步</el-button>
        </div>
        <!-- 审查弹窗 -->
        <el-dialog title="符合性审查" custom-class='pdfDialog' :visible.sync="dialogVisible" width="85%" :close-on-click-modal='false' :before-close="saveForm">
            <div class='pdfContent'>
                <div class='scTop'>
                    <P>评审标准：按招标文件要求进行递交。。。。</P>
                    <el-select v-model='dqtbdwId' style="margin:10px 15px 10px 0;width:350px" @change='changeDqtbdw'>
                        <el-option v-for='(item,index) in tbdwList' :key='index' :value='item.id' :label="item.fCQYMC"></el-option>
                    </el-select>
                    <template v-if='role=="Z"'>
                        <el-radio v-model="dqtbdw.rpzt" label="1" class='tg' :disabled="kbxmlc.zt=='2'">通过</el-radio>
                        <el-radio v-model="dqtbdw.rpzt" label="2" :disabled="kbxmlc.zt=='2'">不通过</el-radio>
                        <el-input :disabled="kbxmlc.zt=='2'" placeholder="请填写不通过理由(必填)" type="textarea" style="width:300px;margin-right:10px" v-model='dqtbdw.rpyj' v-if='dqtbdw.rpzt=="2"'></el-input>
                        <el-button v-if="kbxmlc.zt!='2'" type="primary" @click='nextSc("sc")' :disabled="dqtbdw.rpzt=='0'||dqtbdw.rpzt=='2'&&!dqtbdw.rpyj">保存{{isLast?'':"并下一家"}}</el-button>
                    </template>
                    <el-button type="primary" @click='nextSc("look")' v-else>下一家</el-button>
                </div>
                <div :class='[{dbPdf:tbdws.length>0},"scPdf"]'>
                    <div class='clear'>
                        <p class='lf'>{{dqtbdw.fCQYMC}}</p>
                        <a @click='closeDb(0)' v-if='tbdws.length' class='rt'>关闭全部对比</a>
                        <a @click='addTbdw' :class='["rt",{link:tbdws.length>0}]'>添加投标单位</a>
                    </div>
                    <div>
                        <iframe :src="dqtbdw.rpdz" frameborder="0" width="100%" height="100%"></iframe>
                    </div>
                </div>
                <div class='scPdf dbPdf' v-if='tbdws.length'>
                    <div class='clear'>
                        <p class='lf'>{{tbdws[0].fCQYMC}}</p>
                        <a @click='closeDb(1)' class='rt'>关闭对比</a>
                        <a :class='["rt",{link:tbdws.length>0}]' @click='addTbdw'>添加投标单位</a>
                    </div>
                    <div>
                        <iframe :src="tbdws[0].rpdz" frameborder="0" width="100%" height="100%"></iframe>
                    </div>
                </div>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="saveForm()" :disabled="waitLoading">确定</el-button>
            </div>
        </el-dialog>
        <!-- 添加投标单位弹窗 -->
        <el-dialog title="添加投标单位" :visible.sync="addTbdwDialog" width="600px" :close-on-click-modal='false'>
            <el-table
                ref="tbdwTable"
                border
                :data="tbdwTableData"
                style="width: 100%"
            >
                <el-table-column width="50" label="选择">
                    <template slot-scope="scope" v-if='addTbdwDialog'>
                        <el-checkbox v-model="scope.row.flag" :disabled="scope.row.id1==dqtbdwId"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="tbdwmc1" label="投标单位名称" show-overflow-tooltip min-width="200"></el-table-column>
                <el-table-column width="50" label="选择">
                    <template slot-scope="scope" v-if='scope.row.id2&&addTbdwDialog'>
                        <el-checkbox v-model="scope.row.flag2" :disabled="scope.row.id2==dqtbdwId"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="tbdwmc2" label="投标单位名称" show-overflow-tooltip min-width="200"></el-table-column>
            </el-table>
            <div class="clear">
                <myPage
                :total="total2"
                :page-size="pageSize2"
                :currentPage="currentPage2"
                @changePage="changePage2"
                ></myPage>
            </div>
            <div class="btnBox">
                <el-button type="primary" @click="saveAddTbdw()" :disabled="waitLoading">确定</el-button>
                <el-button type="primary" @click="addTbdwDialog=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myPage from '../components/page'
export default {
    name:'fhxsc',
    components:{
        myPage
    },
    data(){
        return {
            waitLoading:false,
            kbxmlc:{},
            djlcId: "", //当前节点状态
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            sctg:0,
            scbtg:0,
            tbdwmc: "",
            multipleSelection:[],
            isOk:false,
            dialogVisible:false,//审查弹窗
            tbdwList:[],
            dqtbdw:{},//当前投标单位obj
            dqtbdwId:'',
            addTbdwDialog:false,
            tbdwTableData:[{}],//所有投标单位
            total2:0,
            currentPage2:1,
            pageSize2:20,
            tbdws:[],//选中要对比的投标单位
            isLast:false,//是否最后一家
            role:localStorage.getItem('role')?localStorage.getItem('role'):'T'
        }
    },
    computed: {
        isTbr() {
            return ["B"].includes(this.role);
        }
    },
    methods:{
        getData(){
            let para={
                currentPage:this.currentPage,
                pageSize:this.pageSize,
                tbdwmc:this.tbdwmc,
                djlcId:this.djlcId
            }
            this.waitLoading=true
            this.$api.fhxscList(para).then(res=>{
                if(res.data.meta.success){
                    this.total=res.data.data.total;
                    this.kbxmlc=res.data.data.kbxmlc;
                    this.tableData=res.data.data.tbdwList;
                    this.sctg=res.data.data.tgSize;
                    this.scbtg=res.data.data.wtgSize;
                    this.isOk=res.data.data.sfpswc
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //查询
        serachData() {
            this.currentPage = 1;
            this.getData();
        },

        //审查
        sc(){
            let para={
                currentPage:0,
                pageSize:0
            }
            this.waitLoading=true
            this.$api.getTbdwList(para).then(res=>{
                if(res.data.meta.success){
                    this.tbdwList=res.data.data.tbdwList;
                    if(this.multipleSelection.length){
                        this.dqtbdw=this.multipleSelection[0];
                        this.dqtbdwId=this.multipleSelection[0].id;
                        this.tbdwList.forEach((item,index)=>{
                            if(item.id==this.dqtbdwId&&index==this.tbdwList.length-1){
                                this.isLast=true;
                            }
                        })
                    }else{
                        this.dqtbdw=this.tbdwList[0];
                        this.dqtbdwId=this.tbdwList[0].id
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
            this.dialogVisible=true;
        },
        //下拉选择当前投标单位
        changeDqtbdw(id){
            this.dqtbdw={}
            this.tbdwList.forEach((item,index)=>{
                if(item.id==id){
                    this.dqtbdw=item;
                    if(index==this.tbdwList.length-1){
                        this.isLast=true;
                    }else{
                        this.isLast=false;
                    }
                }
            })
        },
        //保存当前审查并下一家
        nextSc(lx){
            if(lx=="sc"){
                let para={
                id:this.dqtbdw.id,
                rpzt:this.dqtbdw.rpzt,
                rpyj:this.dqtbdw.rpzt=='2'?this.dqtbdw.rpyj:''
                }
                this.$api.saveTbdw(para).then(res=>{
                    if(res.data.meta.success){
                        let i;
                        this.tbdwList.forEach((item,index)=>{
                            if(item.id==this.dqtbdwId){
                                i=index;
                                if(index!=this.tbdwList.length-1){
                                    this.isLast=false;
                                }else{
                                    this.isLast=true;
                                }
                            }
                        })
                        this.$message({
                            type:'success',
                            message:'审查结果保存成功！'
                        });
                        this.dqtbdwId=this.tbdwList[i+1].id;
                        this.dqtbdw=this.tbdwList[i+1]
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }else{
                let i;
                this.tbdwList.forEach((item,index)=>{
                    if(item.id==this.dqtbdwId){
                        i=index;
                        if(index!=this.tbdwList.length-1){
                            this.isLast=false;
                        }else{
                            this.isLast=true;
                        }
                    }
                })
                this.dqtbdwId=this.tbdwList[i+1].id;
                this.dqtbdw=this.tbdwList[i+1]
            }
        },
        //关闭弹窗
        saveForm(){
            this.dialogVisible=false;
            this.dqtbdw={};
            this.getData();
            this.tbdws=[];
            this.multipleSelection=[];
        },
        getTbdws(){
            let para={
                currentPage:this.currentPage2,
                pageSize:this.pageSize2
            }
            this.waitLoading=true
            this.$api.getTbdwList(para).then(res=>{
                if(res.data.meta.success){
                    this.total2=res.data.data.total;
                    this.tbdwTableData=[]
                    if(res.data.data.total){
                        res.data.data.tbdwList.forEach((obj,index)=>{
                            if(index%2==0){
                                this.tbdwTableData.push({tbdwmc1:obj.fCQYMC,id1:obj.id,rpdz:obj.rpdz})
                            }else{
                                this.tbdwTableData[this.tbdwTableData.length-1].tbdwmc2=obj.fCQYMC;
                                this.tbdwTableData[this.tbdwTableData.length-1].id2=obj.id;
                                this.tbdwTableData[this.tbdwTableData.length-1].rpdz2=obj.rpdz;
                            }
                            
                        })
                    }
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //添加对比投标单位
        addTbdw(){
            this.addTbdwDialog=true;
            this.getTbdws();
        },
        //保存选中的对比投标单位
        saveAddTbdw(){
            this.tbdwTableData.forEach(item=>{
                if(item.flag){
                    this.tbdws.push({id:item.id1,fCQYMC:item.tbdwmc1,rpdz:item.rpdz})
                }
                if(item.flag2){
                    this.tbdws.push({id:item.id2,fCQYMC:item.tbdwmc2,rpdz:item.rpdz2})
                }
            })
            this.addTbdwDialog=false
        },
        //关闭对比
        closeDb(index){
            if(index==0){
                this.tbdws=[];
            }else{
                this.tbdws.shift();
            }
        },
        //一键审查
        yjsc(){
            this.$confirm('一键审查给定的默认结果只是方便快速评审，不代表系统给出的参考值，建议根据投标文件逐项评审!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let para={}
                this.$api.fhxscYjps(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'一键审查成功！'
                        })
                        this.getData();
                    }
                }).catch(()=>{})
            }).catch(() => {});
        },
        dcFhxsc(){
            let para={}
            this.waitLoading=true
            this.$api.dcFhxsc(para).then(res=>{
                let fileName = decodeURI(res.headers["content-disposition"].split("=")[1]);
                let blob = new Blob([res.data])
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName)
                } else {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = fileName
                    link.click()
                    //释放内存
                    window.URL.revokeObjectURL(link.href)
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        //多选表格
        handleSelectionChange(val) {
            if (val.length>1) return
            this.multipleSelection = val;
        },
        select (selection, row) {
            // 清除所有选中
            this.$refs.table.clearSelection()
            if (selection.length === 0) return
            // 将当前点击项选中
            this.$refs.table.toggleRowSelection(row, true)
        },
        onSelectAll () {
            this.$refs.table.clearSelection();
        },
        changePage(page){
            this.currentPage=page;
            this.getData();
        },
        changePage2(page){
            this.currentPage2=page;
            this.getTbdws();
        },
        nextBtn() {
             this.$confirm('请确认是否提交数据并进入下一步，确认后评审结果不可修改', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let para = {
                    flag:this.kbxmlc.ycdz
                };
                this.waitLoading=true
                this.$emit("nextBtn", para);
            }).catch(() => {});
        },
        onSelectedDrug(e){
            let obj = {};
            obj = this.tableData.find((item)=>{//这里的userList就是上面遍历的数据源
                return item.id === e;//筛选出匹配数据
            });
            this.dqtbdw=obj;
        }
    },
    mounted(){
        this.djlcId = this.$route.query.djlcId;
        this.getData();   
    }
}
</script>
<style lang="less">
.pdfDialog{
    height: 95%;
    .el-dialog__body{
        height: calc(~"100% - 55px");
        .pdfContent{
            height: calc(~"100% - 52px");
            .scTop{
                border:1px solid #ddd;
                background:@base-Bg;
                padding:10px;
                margin-bottom:10px;
                .tg .el-radio__input.is-checked .el-radio__inner{
                    background:@success-color;
                    border-color:@success-color;
                }
                .tg .el-radio__input.is-checked + .el-radio__label{
                    color:@success-color;
                }
                
            }
            .scPdf{
                border:1px solid #ddd;
                height: calc(~"100% - 107px");
                >div.clear{
                    line-height: 42px;
                    height: 42px;
                    padding:0 10px;
                    border-bottom:1px solid #ddd;
                    p.lf{
                        font-weight: bold;
                        color: #333;
                    }
                    a{
                        text-decoration: underline;
                        color:@base-color;
                        margin:0 5px;
                    }
                    a.link{
                        color: @warning-color;
                    }
                }
                >div.clear+div{
                    height: calc(~"100% - 42px");
                }
            }
            .scPdf.dbPdf{
                width: 50%;
                display: inline-block;
            }
            .scPdf.dbPdf+.scPdf.dbPdf{
                border-left:none;
            }
        }

    }
}

</style>